export default "__VITE_PUBLIC_ASSET__59537e8d__"